import React from "react";

const Loader = () => {
  return (
    <div class="ui inverted segment" style={{ width: "1140px" }}>
      <div class="ui active inverted loader"></div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
  );
};

export default Loader;
